module.exports = __webpack_public_path__ + "static/img/ser-c-1.f415b31.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/setmeal/ser-c-1.png
// module id = mjq1
// module chunks = 1